"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_flatpickr_component_1 = __importDefault(require("vue-flatpickr-component"));
const vue_strict_prop_1 = __importDefault(require("vue-strict-prop"));
const tsx = __importStar(require("vue-tsx-support"));
const icons_1 = require("@codegrade/icons");
const maybe_1 = require("@codegrade/maybe");
const utils_1 = require("@codegrade/utils");
const Icon_1 = require("@/components/Icon");
const Loader_1 = __importDefault(require("@/components/Loader"));
const PromiseLoader_1 = __importDefault(require("@/components/PromiseLoader"));
const calendar_config_1 = require("@/models/calendar_config");
const store_1 = require("@/store");
const utils = __importStar(require("@/utils"));
require("./style.less");
const Button_1 = require("../Button");
exports.default = tsx.component({
    name: 'first-day-of-week-dropdown',
    props: {
        calendarConfig: vue_strict_prop_1.default.ofType().required,
    },
    data() {
        const uniq = utils.getUniqueId();
        return {
            loading: true,
            loadError: maybe_1.Maybe.empty(),
            setPromise: maybe_1.Maybe.empty(),
            buttonId: `calendar-settings-button-${uniq}`,
            modalId: `calendar-settings-modal-${uniq}`,
            firstDayOfWeekId: `first-day-of-week-${uniq}`,
        };
    },
    created() {
        utils.watchedLoad({
            instance: this,
            getValues() {
                return {
                    userId: this.currentUserId,
                };
            },
            load: async ({ userId }) => {
                if (userId > 0) {
                    await this.calendarConfig.load();
                }
            },
            reset: () => {
                this.loadError = maybe_1.Maybe.empty();
                this.loading = true;
            },
            setError: err => {
                this.loadError = maybe_1.Maybe.of(err);
                this.loading = false;
            },
            setResult: () => {
                this.loading = false;
            },
        });
    },
    computed: {
        currentUserId() {
            return store_1.UserStore.id();
        },
        currentCalendarConfig() {
            return this.calendarConfig.get();
        },
        firstDayOfWeek() {
            return this.currentCalendarConfig.firstDayOfWeek;
        },
        flatpickrConfig() {
            return {
                static: true,
                enableTime: true,
                time_24hr: true,
                minuteIncrement: 1,
                locale: {
                    firstDayOfWeek: this.firstDayOfWeek,
                },
                mode: 'single',
            };
        },
        modalNode() {
            return (<b-modal id={this.modalId} bodyClass="calendar-settings-modal" size="lg" title="Calendar configuration" okOnly okTitle="Close" okVariant="secondary">
                    <div class="d-flex flex-row">
                        <div class="flex-grow-1">{this.firstDayOfWeekNode}</div>
                        <div class="flex-grow-0 ml-3">{this.calendarNode}</div>
                    </div>
                </b-modal>);
        },
        sortedWeekdays() {
            return utils_1.sort.sortBy(Object.values(calendar_config_1.WEEKDAY_LOOKUP), day => [day.order]);
        },
        firstDayOfWeekNode() {
            return (<b-form-group label="First day of week" labelFor={this.firstDayOfWeekId} description="The first day of the week in calendars.">
                    <b-form-radio-group id={this.firstDayOfWeekId} class="first-day-of-week p-2 border rounded" stacked checked={this.firstDayOfWeek} name="first-day-of-week" options={this.sortedWeekdays.map(({ name, value }) => ({
                    text: name,
                    value,
                }))} disabled={this.setPromise.isJust()} onChange={(firstDayOfWeek) => {
                    this.update({ firstDayOfWeek });
                }}/>

                    <div slot="label">
                        First day of week{' '}
                        {utils.ifJustOrEmpty(this.setPromise, promise => (<PromiseLoader_1.default promise={promise} popoverPlacement="top" onAfterSuccess={() => {
                        this.setPromise = maybe_1.Maybe.empty();
                    }} onAfterError={() => {
                        this.setPromise = maybe_1.Maybe.empty();
                    }} doRetry={() => {
                        this.update({});
                    }}/>))}
                    </div>
                </b-form-group>);
        },
        calendarNode() {
            return (<b-form-group label="Preview" description="This is a preview of the calendar.">
                    <vue_flatpickr_component_1.default ref="flatpickr-calendar" class="form-control" value={new Date()} config={this.flatpickrConfig}/>
                </b-form-group>);
        },
        buttonPopover() {
            return (<b-popover target={this.buttonId} triggers="hover focus" placement="top" customClass="text-left" variant={this.loadError.mapOrDefault(() => 'danger', 'secondary')}>
                    {this.loadError.caseOf({
                    Nothing: () => 'Calendar settings',
                    Just: ({ error, retry }) => (<div class="clearfix">
                                <vue_strict_prop_1.default class="mb-2">
                                    The calendar settings could not be loaded: {error.message}
                                </vue_strict_prop_1.default>
                                <b-button size="sm" variant="danger" onClick={() => retry()} class="float-right">
                                    Retry
                                </b-button>
                            </div>),
                })}
                </b-popover>);
        },
    },
    methods: {
        update(value) {
            this.setPromise = maybe_1.Maybe.of(this.calendarConfig.set({
                ...this.calendarConfig.get(),
                ...value,
            }));
        },
    },
    render() {
        return (<Button_1.Button id={this.buttonId} buttonClasses="calendar-settings size-9" v-b-modal={this.modalId} semantic={this.loadError.mapOrDefault(() => 'critical', 'neutral')} prominence={2} action={() => { }}>
                {utils.ifExpr(this.loading, () => (<Loader_1.default scale={1}/>), () => [
                <Icon_1.Icon icon={icons_1.Settings}/>,
                <span class="sr-only">Calendar Settings</span>,
                this.buttonPopover,
                this.modalNode,
            ])}
            </Button_1.Button>);
    },
});
